import { Step } from "react-joyride";
import { NewProjectBtnSteps } from "./steps/new-project-btn";
import { TypeClsSteps } from "./steps/type-cls";
import { CreateDatasetBtnSteps } from "./steps/create-dataset-btn";
import { DatasetModalSteps } from "./steps/dataset-modal";
import { TrainOptionSettingSteps } from "./steps/train-option-setting";
import { ClsTrainWorkSteps } from "./steps/cls-train-work";
import { ClsMoveInspSteps } from "./steps/cls-move-insp";
import { InspProjectSteps } from "./steps/insp-project";
import { InspProgressSteps } from "./steps/insp-progress";
import { InspHistogramSteps } from "./steps/insp-histogram";
import { TutorialKey } from "../context/TutorialContext";
import { AnaLabelingSteps } from "./steps/ana-labeling";
import { InspStatusSteps } from "./steps/insp-status";
import { InspStatusModalSteps } from "./steps/insp-status-modal";
import { MakeDatasetModalSteps } from "./steps/make-dataset-modal";
import { EnterProjectSteps } from "./steps/enter-project";
import { TypeAnaSteps } from "./steps/type-analysis";
import { AnaTrainOptionSettingSteps } from "./steps/analysis-train-option-setting";
import { ReportCreateSteps } from "./steps/report-create";
import { TypeInspSteps } from "./steps/type-insp";
import { InspTrainSteps } from "./steps/insp-train";
import { InspTrainOptionSteps } from "./steps/insp-train-option";

export type TutorialStep = {
  target: string;
  content: string;
  placement?: Step["placement"];
  spotlightClicks?: boolean;
  hideFooter?: boolean;
  disableOverlayClose?: boolean;
  nextTrigger?: string;
  skipTarget?: string;
};

export const TUTORIALS: Record<TutorialKey, TutorialStep[]> = {
  "cls-project": [
    ...NewProjectBtnSteps,
    ...TypeClsSteps,
    ...CreateDatasetBtnSteps,
    ...DatasetModalSteps,
    ...TrainOptionSettingSteps,
    ...ClsTrainWorkSteps,
    ...ClsMoveInspSteps,
    ...InspProjectSteps,
    ...InspProgressSteps,
    ...InspHistogramSteps,
  ],

  "inspection-project": [
    ...NewProjectBtnSteps,
    ...TypeInspSteps,
    ...CreateDatasetBtnSteps,
    ...DatasetModalSteps,
    ...InspTrainOptionSteps,
    ...InspTrainSteps,
    ...InspProgressSteps,
  ],

  "analysis-project": [
    // ...NewProjectBtnSteps,
    // ...TypeAnaSteps,
    // ...CreateDatasetBtnSteps,
    // ...DatasetModalSteps,
    // ...AnaTrainOptionSettingSteps,
    ...AnaLabelingSteps,
  ],
  "inspection-status": [...InspStatusSteps, ...InspStatusModalSteps, ...MakeDatasetModalSteps],
  "report-generation": [...EnterProjectSteps, ...ReportCreateSteps],
};
